// extracted by mini-css-extract-plugin
export default {"header":"header_header__Ink+Y","violation-icon":"header_violation-icon__tRt2P"};